import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAdvertiser } from '../actions/advertiserActions';
import { getAdvertisers } from '../actions/advertisersActions';
import { setOrder } from '../actions/orderActions';
import Spinner from '../components/Spinner';
import AdvertiserPage from '../components/Advertiser';
import ErrorPage from '../errors/ErrorPage';
import { TrackingCtx } from '../tracking'
import {isReadOnly} from "../utils/readOnly";

class Advertiser extends Component {

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(setOrder({}));
    if (match.params.id) {
      dispatch(getAdvertiser(match.params.id)).then(() => {
        if (this.props.selectedAdvertiser && this.props.selectedAdvertiser.name) {
          document.title = `Advertiser ${this.props.selectedAdvertiser.name} - GALILEO`;
        }
      });
    }
    dispatch(getAdvertisers());
    document.title = `Advertisers - GALILEO`;
  }

  onChange = (selectedAdvertiser) => {
    const { dispatch, history } = this.props;
    dispatch(getAdvertiser(selectedAdvertiser.id));
    history.push(`/advertiser/${selectedAdvertiser.id}`)
  };

  render() {
    const {
      advertisers,
      selectedAdvertiser,
      isFetchingAdvertisers,
      isFetching,
      error,
      dispatch,
      userInfo
    } = this.props;

    return (
      <div>
        {isFetchingAdvertisers && <Spinner />}
        {!isFetchingAdvertisers && error && !advertisers && (
          <ErrorPage error={error} entity="advertiser" />
        )}
        {!isFetchingAdvertisers && advertisers && (
        <TrackingCtx.Provider value={{category:"Advertiser", action:"Advertiser Page", label: `${selectedAdvertiser?'Advertiser#'+selectedAdvertiser.id : ''}`}}>        
        <AdvertiserPage
          advertisers={advertisers}
          onChange={this.onChange}
          selectedAdvertiser={selectedAdvertiser}
          isFetchingAdvertisers={isFetchingAdvertisers}
          isFetching={isFetching}
          error={error}
          dispatch={dispatch}
          isReadOnly={isReadOnly(userInfo)}
        />
        </TrackingCtx.Provider>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { advertisersRequest, advertiserRequest, user } = state;
  return {
    advertisers: advertisersRequest.advertisers,
    selectedAdvertiser: advertiserRequest.advertiser,
    isFetchingAdvertisers: advertisersRequest.isFetching,
    isFetching: advertiserRequest.isFetching,
    error: advertisersRequest.error || advertiserRequest.error,
    userInfo: {
      name: user.displayName,
      email: user.email,
      role: user.roleName
    },
  }
};

export default connect(mapStateToProps)(Advertiser);
